exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insensitive[data-v-7cc09742]{display:inline-block}.img-container[data-v-7cc09742],.infodisplay[data-v-7cc09742]{display:flex;align-items:center}.img-container[data-v-7cc09742]{margin-left:10px}.toggle-icon[data-v-7cc09742]{width:20px;height:auto}", ""]);

// exports
